import React from "react";

const Loader = ({ className, children }) => {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-white dark:bg-gray-800 z-50 ${className}`}
    >
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-primary-500"></div>
      {children}
    </div>
  );
};

export default Loader;
